import type { Observable } from 'rxjs';
import type { MagicLinkPreflightOutcome } from '../models/magic-link-preflight.model';
import type { PublicLeaderboardLoadOutcome } from '../models/leaderboard-unavailable.model';

export interface LoadPublicLeaderboardParams {
  commerceId: number;
  leaderboardId: string;
  uid?: string | null;
  rankingQuery?: string | null;
  rankingPage?: number;
  rankingLimit?: number;
}

export interface LoadMagicLinkPreflightParams {
  commerceId: number;
  leaderboardId: string;
  uid: string;
}

export abstract class LeaderboardPublicPort {
  abstract loadPublic(params: LoadPublicLeaderboardParams): Observable<PublicLeaderboardLoadOutcome>;

  abstract loadMagicLinkPreflight(
    params: LoadMagicLinkPreflightParams,
  ): Observable<MagicLinkPreflightOutcome>;
}
